import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { Mixpanel } from 'helpers/Mixpanel';
import '../Cell/Cell.scss';
import presenter from 'pages/ScheduleCalendar/duck/presenter';
import styled from '../Cell/styled';
import draftLogic from 'pages/ScheduleCalendar/duck/draftLogic';
import { isValidObject } from 'helpers/validation';
import { getShiftDetails } from '../shared/cellUtils';
import { getRoleTagColor, findFirstRoleTag} from 'pages/ScheduleCalendar/duck/tagUtil';
import constants from 'pages/ScheduleCalendar/constants';

export function OpenShiftDraggableCell ({user,
    shifts,
    selectedDateToAddShift,
    date,
    handleOpenShiftDetail,
    copyOpenShiftToDateDispatch,
    shiftToCopy,
    isCopyingShift,
    roles,
    }) {

  const ref = useRef(null);

  const canDragOpenShift = useCallback(() => {
    if( shifts != null ){
      const shiftToDrag = shifts[0];
      if( shiftToDrag != null){
        if ( shiftToDrag.trade_status === 'unpublished_posted') { 
          return true;
        }else{
          return false;
        }
      }
    }
    return false;
  }, [shifts]);

  const [{isDragging, canDrag}, drag] = useDrag(() => ({
    type: 'OpenShiftCell',
    item: () => (shifts?.length ? shifts[0] : { id: 0 }),
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag:  canDragOpenShift(),
  }), [canDragOpenShift, shifts])

  drag(ref);

  const [isMouseOverCell, setIsMouseOverCell] = useState(false);

  const onCellClick = useCallback(() => {
    if (shifts && shifts.length > 0) {
      Mixpanel.track('View open shift detail', { 'date': date.format('YYYY-MM-DD') });
      handleOpenShiftDetail(shifts[0], date);
    } else {
      setIsMouseOverCell(false);
      selectedDateToAddShift(user, date, constants.ShiftCreationType.OpenShift);

      Mixpanel.track('Add Open Shift ', { 'date': date.format('YYYY-MM-DD') });
    }
  }, [shifts, user, date, handleOpenShiftDetail, selectedDateToAddShift]);

  const onPasteClick = useCallback(() => {
    setIsMouseOverCell(false);
    copyOpenShiftToDateDispatch(shiftToCopy, date, shiftToCopy.location_id);
    Mixpanel.track('Paste Open Shift');
  }, [copyOpenShiftToDateDispatch, shiftToCopy, user, date]);

  const onEmptyCellMouseEnter = () => { setIsMouseOverCell(true); };
  const onEmptyCellMouseLeave = useCallback(() => { setIsMouseOverCell(false); }, []);
 
  if ( isValidObject(shifts) == false || shifts.length === 0) {
    if (isCopyingShift && shiftToCopy !== null) {
      if( draftLogic.isDraftOpenShift(shiftToCopy) == true || draftLogic.isOpenShift(shiftToCopy) == true ){
        return presenter.pasteShiftCell(onPasteClick, onEmptyCellMouseEnter, onEmptyCellMouseLeave, isMouseOverCell);
      }else{
        return (<br/>);
      }
    } else {
      return presenter.addNewShiftCell(onCellClick, onEmptyCellMouseEnter, onEmptyCellMouseLeave, isMouseOverCell);
    }
  }

  const shiftObject = shifts[0];
  const { position, hours, timeRange } = getShiftDetails(shiftObject);
  const tagText = presenter.statusTagForOpenShiftCard(shiftObject)
  const isDraftShift = draftLogic.isDraftOpenShift(shiftObject);
  const roleTagColor = getRoleTagColor(roles, shiftObject);
  const roleTag = findFirstRoleTag(roles, shiftObject);
  const positionOrRoleName = presenter.getRoleNameOrJobTitle([roleTag], position);
  const cardName = presenter.cardClassNameForOpenShift(shiftObject);

  const bottomLine = (
    <styled.DayCellBottomLineWrap>
      <styled.DayCellTextPosition>{positionOrRoleName}</styled.DayCellTextPosition>
      {typeof positionOrRoleName === 'string' && positionOrRoleName.length > 0 && <styled.Dot />}
      <styled.BottomLineText>{presenter.textHours(hours)}</styled.BottomLineText>
    </styled.DayCellBottomLineWrap>
  );
  // console.log("RoleTagColor:", roleTagColor, "ShiftObject:", shiftObject, "roles:", roles);

  return (
    <div className= {"day-cell-top-wrap " + cardName } ref={ref} onMouseUpCapture={onCellClick} key= {shifts[0].id}>
        {tagText !== '' && <span className='status-tag'> {tagText} </span>}

        <div className= {(isDraftShift) ? 'day-cell dotted-border': 'day-cell solid-border'} style={{backgroundColor: presenter.backgroundColorFromRoleTagColor(roleTagColor), borderColor: presenter.borderColorFromRoleTagColor(roleTagColor)}}>
          <div className='top-row'> <label className='quantity-bubble'> {shiftObject.total_shifts_available} </label> <label className='time-label'> {timeRange} </label> </div>
          {bottomLine}
        </div>

    </div>
  );

};

export default OpenShiftDraggableCell; 